/* 🤖 this file was generated by svg-to-ts */
export const matIconExpandCircleDown: {
  name: 'expand-circle-down';
  data: string;
} = {
  name: 'expand-circle-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.08 9.59 12 12.67 8.92 9.59 7.5 11l4.5 4.5 4.5-4.5-1.42-1.41zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/></svg>`
};
